module.exports = __webpack_public_path__ + "media/images/pages/icn_balloon_purpose_school_purple-1f41de786c6361686de3a0e93124ed41.svg";